var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_929_8775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63269 15V4.87947H0.202386V15H3.63269ZM1.91798 3.49686C3.11419 3.49686 3.85877 2.71972 3.85877 1.74856C3.83648 0.755504 3.11423 -6.10352e-05 1.94068 -6.10352e-05C0.767312 -6.10352e-05 0 0.755519 0 1.74856C0 2.71977 0.744398 3.49686 1.89559 3.49686H1.91787H1.91798ZM5.53135 15H8.96165V9.34818C8.96165 9.0457 8.98394 8.74354 9.07452 8.52732C9.32251 7.92298 9.88693 7.29706 10.8345 7.29706C12.0758 7.29706 12.5724 8.22514 12.5724 9.58564V14.9999H16.0025V9.19689C16.0025 6.08827 14.3101 4.64187 12.0532 4.64187C10.2027 4.64187 9.39021 5.6562 8.93883 6.34705H8.96173V4.87926H5.53143C5.57644 5.82891 5.53143 14.9997 5.53143 14.9997L5.53135 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_929_8775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2c846ac4f72646ba9b03df2e13372696.svg";
export { ForwardRef as ReactComponent };